import { createSlice } from '@reduxjs/toolkit';

import { getPrevNextIds } from '../../helpers/common';

import { createFarm, deleteFarm, deleteFarms, fetchFarm, fetchFarms, updateFarm } from '../actions/farm';

const farmSlice = createSlice({
  name: 'farm',
  initialState: {
    error: null,
    farm: null,
    list: [],
    loading: false,
    options: [],
    sortedData: []
  },
  reducers: {
    setSortedData: (state, action) => {
      state.sortedData = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      // Create Farm
      .addCase(createFarm.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createFarm.fulfilled, (state, action) => {
        state.loading = false;
        state.farm = action.payload;
      })
      .addCase(createFarm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Farms
      .addCase(fetchFarms.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFarms.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.options = action.payload.options;
        state.filterOptions = action.payload.filterOptions;
      })
      .addCase(fetchFarms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Farm
      .addCase(fetchFarm.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFarm.fulfilled, (state, action) => {
        const { prev_id, next_id } = state.sortedData?.length
          ? getPrevNextIds(state.sortedData, action.payload?.id)
          : { prev_id: action.payload.prev_id, next_id: action.payload.next_id };
        state.farm = { ...action.payload, prev_id, next_id };
        state.loading = false;
      })
      .addCase(fetchFarm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Farm
      .addCase(updateFarm.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateFarm.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateFarm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Farms
      .addCase(deleteFarms.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFarms.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.filter(record => !action.payload?.includes(record.id));
      })
      .addCase(deleteFarms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Farm
      .addCase(deleteFarm.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFarm.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteFarm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSortedData } = farmSlice.actions;
export default farmSlice.reducer;
